/* Lumiere theme — global interactivity */
(function () {
  'use strict';

  /* --- Mobile menu toggle --- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var nav = document.querySelector('[data-menu]');
      if (!nav) return;
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  /* --- Desktop dropdown mega-menu: hover-open + dim overlay --- */
  var navOverlay = document.querySelector('[data-nav-overlay]');
  document.querySelectorAll('[data-dropdown-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-dropdown-trigger]');

    var open = function () {
      item.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (navOverlay) navOverlay.classList.add('is-visible');
    };
    var close = function () {
      item.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (navOverlay) navOverlay.classList.remove('is-visible');
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close();
    });

    if (trigger) {
      trigger.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          close();
        } else {
          open();
        }
      });
    }
  });

  /* --- Transparent header: turn solid once the visitor scrolls past the hero --- */
  var transparentHeader = document.querySelector('[data-header-transparent]');
  if (transparentHeader) {
    var toggleScrolled = function () {
      transparentHeader.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    toggleScrolled();
    window.addEventListener('scroll', toggleScrolled, { passive: true });
  }

  /* --- Quantity plus / minus buttons --- */
  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var wrapper = (minus || plus).closest('.quantity');
    var input = wrapper && wrapper.querySelector('[data-qty-input]');
    if (!input) return;

    var value = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10);
    if (isNaN(min)) min = 0;

    value = plus ? value + 1 : value - 1;
    if (value < min) value = min;

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --- Collection sorting --- */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  /* --- Product variant picker --- */
  var productSection = document.querySelector('[data-product-section]');
  if (productSection) {
    var variantJsonEl = productSection.querySelector('[data-variant-json]');
    var stringsJsonEl = productSection.querySelector('[data-strings-json]');
    var optionSelects = productSection.querySelectorAll('[data-option-select]');

    if (variantJsonEl && optionSelects.length > 0) {
      var variants = JSON.parse(variantJsonEl.textContent);
      var strings = stringsJsonEl
        ? JSON.parse(stringsJsonEl.textContent)
        : { addToCart: 'Add to cart', soldOut: 'Sold out', unavailable: 'Unavailable' };

      var formatMoney = function (cents) {
        var priceEl = productSection.querySelector('[data-price]');
        var sample = priceEl ? priceEl.textContent.trim() : '';
        var amount = (cents / 100).toFixed(2);
        // Reuse the currency symbol from the server-rendered price when possible.
        var symbolMatch = sample.match(/^[^\d]*/);
        var symbol = symbolMatch ? symbolMatch[0] : '';
        return symbol + amount;
      };

      var onVariantChange = function () {
        var selectedOptions = [];
        optionSelects.forEach(function (select) {
          selectedOptions[parseInt(select.dataset.position, 10) - 1] = select.value;
        });

        var matched = variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selectedOptions[index];
          });
        });

        var idInput = productSection.querySelector('[data-variant-id]');
        var addButton = productSection.querySelector('[data-add-button]');
        var priceEl = productSection.querySelector('[data-price]');
        var compareEl = productSection.querySelector('[data-compare-price]');
        var saleBadge = productSection.querySelector('[data-sale-badge]');
        var notifyWrapper = productSection.querySelector('[data-notify-wrapper]');

        if (!matched) {
          if (addButton) {
            addButton.disabled = true;
            addButton.textContent = strings.unavailable;
          }
          if (notifyWrapper) notifyWrapper.hidden = false;
          return;
        }

        if (notifyWrapper) notifyWrapper.hidden = matched.available;

        if (idInput) idInput.value = matched.id;

        if (priceEl) priceEl.textContent = formatMoney(matched.price);

        var onSale = matched.compare_at_price && matched.compare_at_price > matched.price;
        if (compareEl) {
          compareEl.hidden = !onSale;
          if (onSale) compareEl.textContent = formatMoney(matched.compare_at_price);
        }
        if (saleBadge) saleBadge.hidden = !onSale;

        if (addButton) {
          addButton.disabled = !matched.available;
          addButton.textContent = matched.available ? strings.addToCart : strings.soldOut;
        }
      };

      optionSelects.forEach(function (select) {
        select.addEventListener('change', onVariantChange);
      });
    }
  }

  /* --- Slideshow: handled by the <slide-show-{{ section.id }}> web component in sections/slideshow.liquid --- */

  /* --- Tabbed collection --- */
  document.querySelectorAll('[data-tabbed]').forEach(function (tabbed) {
    var buttons = tabbed.querySelectorAll('[data-tab-button]');
    var panels = tabbed.querySelectorAll('[data-tab-panel]');
    if (buttons.length === 0) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.dataset.tabButton;
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.tabButton === target);
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.tabPanel === target);
        });
      });
    });
  });

  /* --- Liquid-fill button hover: rises in on enter, drains out the top on
     leave (one-directional, not a reverse of the entrance). Switching
     which class is active WITHOUT forcing a reflow in between lets the
     transition keep animating from wherever it currently is (even
     mid-flight) toward the new target, instead of snapping back to the
     hidden base position first — so leaving mid-rise continues upward
     from that exact spot rather than restarting from the bottom. --- */
  document.querySelectorAll('.button--outline-light').forEach(function (btn) {
    var resetTimer;

    btn.addEventListener('mouseenter', function () {
      clearTimeout(resetTimer);
      btn.classList.remove('is-draining');
      btn.classList.add('is-filling');
    });

    btn.addEventListener('mouseleave', function () {
      btn.classList.remove('is-filling');
      btn.classList.add('is-draining');
      resetTimer = setTimeout(function () {
        btn.classList.remove('is-draining');
      }, 1150);
    });
  });
})();

/* --- Cart drawer + AJAX cart --------------------------------------------------- */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var config = window.theme || {};
  var routes = config.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var moneyFormat = config.moneyFormat || '${{amount}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withCommas(number) {
      return number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }
    function withDots(number) {
      return number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
    }

    function defaultTo(dec) {
      var amount = (cents / 100.0).toFixed(dec);
      return amount;
    }

    var match = moneyFormat.match(placeholderRegex);
    var token = match ? match[1] : 'amount';

    switch (token) {
      case 'amount':
        value = withCommas(defaultTo(2));
        break;
      case 'amount_no_decimals':
        value = withCommas(defaultTo(0));
        break;
      case 'amount_with_comma_separator':
        value = withDots(defaultTo(2)).replace(/\.(\d\d)$/, ',$1');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDots(defaultTo(0));
        break;
      default:
        value = withCommas(defaultTo(2));
    }
    return moneyFormat.replace(placeholderRegex, value);
  }

  function imageWidth(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!drawer) return;

    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footerEl = drawer.querySelector('[data-cart-footer]');
    /* The <template> lives as a sibling of .cart-drawer in the markup
       (not nested inside it), so it must be looked up from the document,
       not scoped to the drawer element. */
    var tmpl = document.querySelector('[data-cart-item-template]');
    if (!itemsEl || !tmpl) return;

    itemsEl.innerHTML = '';

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.hidden = false;
      if (footerEl) footerEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footerEl) footerEl.hidden = false;

    cart.items.forEach(function (item) {
      var node = tmpl.content.firstElementChild.cloneNode(true);
      node.setAttribute('data-key', item.key);

      node.querySelectorAll('[data-item-url]').forEach(function (a) { a.href = item.url; });

      var img = node.querySelector('[data-item-image]');
      if (img) {
        if (item.image) {
          img.src = imageWidth(item.image, 200);
          img.alt = item.product_title;
        } else {
          var media = node.querySelector('.cart-drawer-item__media');
          if (media) media.remove();
        }
      }

      var titleEl = node.querySelector('[data-item-title]');
      if (titleEl) titleEl.textContent = item.product_title;

      var variantEl = node.querySelector('[data-item-variant]');
      if (variantEl && item.variant_title) {
        variantEl.textContent = item.variant_title;
        variantEl.hidden = false;
      }

      var qtyEl = node.querySelector('[data-item-qty]');
      if (qtyEl) qtyEl.value = item.quantity;

      var priceEl = node.querySelector('[data-item-price]');
      if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);

      itemsEl.appendChild(node);
    });

    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function fetchCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeQuantity(key, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(formData, button) {
    /* Icon-only buttons (e.g. the round quick-add on product cards) have no
       text to swap out — only text buttons get the "…" loading label, icon
       buttons just get disabled + a dimmed .is-loading class instead. */
    var isTextButton = button && button.children.length === 0;
    var original = isTextButton ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
      if (isTextButton) button.textContent = '…';
    }

    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || 'Could not add to cart'); }
        return fetchCart();
      })
      .then(function () { openCart(); })
      .catch(function (err) { window.alert(err.message); })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.classList.remove('is-loading');
          if (isTextButton) button.textContent = original;
        }
      });
  }

  /* Open drawer from header cart icon */
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (!drawer) return;
      e.preventDefault();
      openCart();
      fetchCart();
    });
  });

  /* Close interactions */
  if (drawer) {
    drawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); closeCart(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    /* Item quantity + remove (event delegation) */
    drawer.addEventListener('click', function (e) {
      var row = e.target.closest('[data-line-item]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var input = row.querySelector('[data-item-qty]');
      var current = parseInt(input.value, 10) || 0;

      if (e.target.closest('[data-item-plus]')) {
        changeQuantity(key, current + 1);
      } else if (e.target.closest('[data-item-minus]')) {
        changeQuantity(key, Math.max(0, current - 1));
      } else if (e.target.closest('[data-item-remove]')) {
        changeQuantity(key, 0);
      }
    });

    drawer.addEventListener('change', function (e) {
      var row = e.target.closest('[data-line-item]');
      if (!row || !e.target.matches('[data-item-qty]')) return;
      var key = row.getAttribute('data-key');
      var qty = Math.max(0, parseInt(e.target.value, 10) || 0);
      changeQuantity(key, qty);
    });
  }

  /* Intercept the product page add-to-cart form for AJAX + drawer */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm && drawer) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var button = productForm.querySelector('[data-add-button]');
      addToCart(new FormData(productForm), button);
    });
  }

  /* --- Product card: quick add (round cart button) --- */
  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-quick-add]');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    if (button.disabled || !button.dataset.variantId) return;

    var formData = new FormData();
    formData.append('id', button.dataset.variantId);
    formData.append('quantity', 1);
    addToCart(formData, button);
  });

  /* --- Product card: quick view modal --- */
  var quickView = document.querySelector('[data-quick-view-modal]');
  if (quickView) {
    var qvLoading = quickView.querySelector('[data-quick-view-loading]');
    var qvBody = quickView.querySelector('[data-quick-view-body]');
    var qvImage = quickView.querySelector('[data-quick-view-image]');
    var qvTitle = quickView.querySelector('[data-quick-view-title]');
    var qvPrice = quickView.querySelector('[data-quick-view-price]');
    var qvCompare = quickView.querySelector('[data-quick-view-compare]');
    var qvOptions = quickView.querySelector('[data-quick-view-options]');
    var qvQty = quickView.querySelector('[data-quick-view-qty]');
    var qvAdd = quickView.querySelector('[data-quick-view-add]');
    var qvLink = quickView.querySelector('[data-quick-view-link]');
    var qvOptionTemplate = document.querySelector('[data-quick-view-option-template]');
    var qvStrings = config.strings || { addToCart: 'Add to cart', soldOut: 'Sold out', unavailable: 'Unavailable' };
    var qvVariants = [];
    var qvSelectedId = null;

    function openQuickView() {
      quickView.classList.add('is-open');
      quickView.setAttribute('aria-hidden', 'false');
      document.body.classList.add('quick-view-open');
    }

    function closeQuickView() {
      quickView.classList.remove('is-open');
      quickView.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('quick-view-open');
    }

    function qvSelectedOptions() {
      var selects = qvOptions.querySelectorAll('[data-quick-view-option-select]');
      var values = [];
      selects.forEach(function (select) {
        values[parseInt(select.dataset.position, 10) - 1] = select.value;
      });
      return values;
    }

    function qvSyncVariant() {
      var hasSelects = qvOptions.querySelectorAll('[data-quick-view-option-select]').length > 0;
      var matched;

      if (hasSelects) {
        var selected = qvSelectedOptions();
        matched = qvVariants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selected[index];
          });
        });
      } else {
        /* Single-variant product — nothing to pick, just use it directly. */
        matched = qvVariants[0];
      }

      if (!matched) {
        qvSelectedId = null;
        qvAdd.disabled = true;
        qvAdd.textContent = qvStrings.unavailable;
        return;
      }

      qvSelectedId = matched.id;
      qvPrice.textContent = formatMoney(matched.price);

      var onSale = matched.compare_at_price && matched.compare_at_price > matched.price;
      qvCompare.hidden = !onSale;
      if (onSale) qvCompare.textContent = formatMoney(matched.compare_at_price);

      if (matched.featured_image && matched.featured_image.src) {
        qvImage.src = imageWidth(matched.featured_image.src, 800);
      }

      qvAdd.disabled = !matched.available;
      qvAdd.textContent = matched.available ? qvStrings.addToCart : qvStrings.soldOut;
    }

    function qvRenderOptions(product) {
      qvOptions.innerHTML = '';
      if (product.variants.length <= 1) return;

      product.options.forEach(function (optionName, index) {
        var position = index + 1;
        var values = [];
        product.variants.forEach(function (variant) {
          var value = variant.options[index];
          if (values.indexOf(value) === -1) values.push(value);
        });

        var node = qvOptionTemplate.content.firstElementChild.cloneNode(true);
        node.querySelector('[data-option-label]').textContent = optionName;

        var select = node.querySelector('[data-quick-view-option-select]');
        select.id = 'QuickViewOption-' + position;
        select.dataset.position = position;
        node.querySelector('[data-option-label]').setAttribute('for', select.id);

        var currentValue = product.variants[0].options[index];
        values.forEach(function (value) {
          var opt = document.createElement('option');
          opt.value = value;
          opt.textContent = value;
          if (value === currentValue) opt.selected = true;
          select.appendChild(opt);
        });

        select.addEventListener('change', qvSyncVariant);
        qvOptions.appendChild(node);
      });
    }

    function loadQuickView(handle) {
      qvLoading.hidden = false;
      qvBody.hidden = true;
      openQuickView();

      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          qvVariants = product.variants;
          qvTitle.textContent = product.title;
          qvLink.href = product.url;
          qvQty.value = 1;

          var image = product.featured_image || (product.images && product.images[0]);
          qvImage.src = image ? imageWidth(image, 800) : '';
          qvImage.alt = product.title;

          qvRenderOptions(product);
          qvSyncVariant();

          qvLoading.hidden = true;
          qvBody.hidden = false;
        })
        .catch(function () {
          closeQuickView();
        });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      loadQuickView(trigger.dataset.productHandle);
    });

    quickView.querySelectorAll('[data-quick-view-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); closeQuickView(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeQuickView();
    });

    qvAdd.addEventListener('click', function () {
      if (!qvSelectedId) return;
      var formData = new FormData();
      formData.append('id', qvSelectedId);
      formData.append('quantity', qvQty.value || 1);
      addToCart(formData, qvAdd).then(closeQuickView);
    });
  }
})();

/* --- Email popup ---------------------------------------------------------- */
(function () {
  'use strict';

  var popup = document.querySelector('[data-email-popup]');
  if (!popup) return;

  var STORAGE_KEY = 'email-popup-hide-until';
  var hideDays = parseInt(popup.dataset.hideDays, 10) || 14;
  var delay = parseInt(popup.dataset.delay, 10) || 0;
  /* Rendered by the section's Liquid when the customer form just posted
     successfully (full-page redirect back to this page). */
  var justSubscribed = document.documentElement.hasAttribute('data-email-popup-subscribed');

  function isHidden() {
    var until = localStorage.getItem(STORAGE_KEY);
    return until && Date.now() < parseInt(until, 10);
  }

  function suppressFor(days) {
    var until = Date.now() + days * 24 * 60 * 60 * 1000;
    localStorage.setItem(STORAGE_KEY, String(until));
  }

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('email-popup-open');
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('email-popup-open');
    suppressFor(hideDays);
  }

  popup.querySelectorAll('[data-email-popup-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closePopup();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  if (justSubscribed) {
    suppressFor(hideDays);
    openPopup();
  } else if (!isHidden()) {
    window.setTimeout(openPopup, delay);
  }
})();
